import { IconName, IconPrefix, findIconDefinition, library } from "@fortawesome/fontawesome-svg-core";
import { fal } from "@fortawesome/pro-light-svg-icons";
import { far } from "@fortawesome/pro-regular-svg-icons";
import { fas } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon, FontAwesomeIconProps } from "@fortawesome/react-fontawesome";

const loadIconPack = (prefix: IconPrefix): void => {
  // Icon packs must be added to library in order to find them.
  switch (prefix) {
    case "far": library.add(far);
      break;
    case "fal": library.add(fal);
      break;
    case "fas": library.add(fas);
      break;
  }
};


type DynamicFontAwesomeIconProps = Omit<FontAwesomeIconProps, "icon"> & {
  name: IconName | string | undefined;
  prefix?: IconPrefix;
}

export const DynamicFontAwesomeIcon = ({ name, prefix = "fal", ...props }: DynamicFontAwesomeIconProps) => {
  if (!name) {
    return null;
  }

  // fontawesome caches so we don't have to worry about rerenders
  loadIconPack(prefix);

  // @ts-expect-error A string may be supplied to lookup an icon, and we can't guarantee that string is an icon name
  const definition = findIconDefinition({ prefix: prefix, iconName: name });
  if (!definition) {
    return null;
  }
  return <FontAwesomeIcon icon={definition} {...props} />
}
